/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";
import { LiveAlertBanner } from "./LiveAlertBanner";
import { PreviewAlertBanner } from "./PreviewAlertBanner";
import { useAlerts } from "cms/hooks/use-alerts";
import { useNavigate } from "react-router-dom";
import { CmsConfig } from "cms/config";

const AlertBanner = () => {

    const isPreview = CmsConfig.isPreview;
    const [showBanner, setShowBanner] = useState(false);
    const [started, setStarted] = useState(false);
    const [collapseBanner, setCollapseBanner] = useState(false);

    const navigate = useNavigate();
    const { loadAlerts, liveAlert, previewAlert, alertLoaded } = useAlerts();
    const alert = isPreview ? previewAlert : liveAlert;
    let enabled = alert?.enabled;

    const handleToggleBanner = () => {
        const collapseState = !collapseBanner;
        sessionStorage.setItem("collapseBanner", collapseState);
        setCollapseBanner(collapseState);
    };

    const onClickBanner = (event, path) => {
        navigate(path);
    };

    useEffect(() => {
        if (alertLoaded) {
            return;
        }
        if (!started) {
            setStarted(true);
            loadAlerts();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [started]);

    useEffect(() => {
        const sessionCollapseBanner = sessionStorage.getItem("collapseBanner") === "true";
        setCollapseBanner(sessionCollapseBanner);
        if (enabled) {
            setShowBanner(true);
        }
    }, [alert, enabled]);

    useEffect(() => {
        const hideBanner = sessionStorage.getItem("hideAlertBanner");
        if (hideBanner) {
            setShowBanner(false);
        }
    }, []);

    return (
        <div>
            {!isPreview && alert && (
                <LiveAlertBanner
                    alert={alert}
                    enabled={enabled}
                    handleToggleBanner={handleToggleBanner}
                    collapseBanner={collapseBanner}
                    showBanner={showBanner}
                    onClickBanner={onClickBanner}
                />
            )}
            {isPreview && alert && (
                <PreviewAlertBanner
                    alert={alert}
                    enabled={enabled}
                    handleToggleBanner={handleToggleBanner}
                    collapseBanner={collapseBanner}
                    showBanner={showBanner}
                    onClickBanner={onClickBanner}
                />
            )}
        </div>
    );
};

export { AlertBanner };
